<script>
	// 필요한 이미지나 데이터를 여기서 임포트
	
	// 기술 스택 데이터
	const techStacks = [
		{
			category: "Front end",
			skills: ["HTML", "CSS", "JavaScript", "TypeScript", "React", "Svelte", "Next.js"]
		},
		{
			category: "Back end",
			skills: ["Node.js", "Express", "Python", "C#", "C++"]
		},
		{
			category: "Database",
			skills: ["MySQL", "MongoDB"]
		},
		{
			category: "DevOps",
			skills: ["Git", "Docker", "Figma"]
		}
	];
</script>

<div class="stack-container">
	<h1>Stack</h1>
	
	{#each techStacks as techStack}
		<div class="stack-category">
			<h2>{techStack.category}</h2>
			<div class="skills-list">
				{#each techStack.skills as skill}
					<div class="skill-item">{skill}</div>
				{/each}
			</div>
		</div>
	{/each}
</div>

<style>
	.stack-container {
		max-width: 800px;
		margin: 80px auto 0;
		padding: 0 20px;
	}

	h1 {
		font-size: var(--font-size-title, 2rem);
		margin-bottom: 1.5rem;
		color: var(--color-text, #000000);
	}

	.stack-category {
		margin-bottom: 2rem;
	}

	h2 {
		margin: 0 0 1rem 0;
		font-size: 1.5rem;
		border-bottom: 1px solid #eee;
		padding-bottom: 0.5rem;
	}

	.skills-list {
		display: flex;
		flex-wrap: wrap;
		gap: 0.8rem;
	}

	.skill-item {
		background-color: #383838;
		padding: 0.5rem 1rem;
		border-radius: 10px;
		font-size: 0.9rem;
		font-weight: 500;
	}
</style>